import { updateQuestion as updateQuestionAPI } from "../api";

export const updateQuestionAction = async (questionObject) => {
  const question = await updateQuestionAPI(questionObject);
  return question.data;
};
